import { render, staticRenderFns } from "./MoveTxgl.vue?vue&type=template&id=ee28d690&scoped=true&"
import script from "./MoveTxgl.vue?vue&type=script&lang=js&"
export * from "./MoveTxgl.vue?vue&type=script&lang=js&"
import style0 from "./MoveTxgl.vue?vue&type=style&index=0&id=ee28d690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee28d690",
  null
  
)

export default component.exports